import FieldValidator from './_FieldValidator';

export default class RequiredFieldValidator extends FieldValidator {
    constructor(message) {
        super(message);
    }

    async validate(value) {
        if (this.#hasValue(value)) {
            return Promise.resolve({ valid: true });
        }

        return Promise.resolve({ valid: false, messages: [{ text: this.message }] });
    }

    #hasValue(value) {
        if (!value) {
            return false;
        }

        return value.length > 0;
    }
}